import { SentimentBgImage, InfoIcon } from 'assets'
import React, { useEffect, useState } from 'react'
import ProgressBar from 'progressbar.js'
import { useSelector } from 'react-redux'

function DRiskScore() {
   const videoRedux = useSelector((state) => state.videoRedux)
   const { videoDetails: videoDetailsData, videoRiskScore } = videoRedux
   const [globalRiskScore, setGlobalRiskScore] = useState(null)

   useEffect(() => {
      if (videoDetailsData?.global_risk_score) {
         let rr =
            (videoRiskScore || videoDetailsData?.risk_score) - videoDetailsData?.global_risk_score
         setGlobalRiskScore(rr.toFixed(1))
      } else {
         setGlobalRiskScore(null)
      }

      return () => {}
   }, [videoDetailsData])

   const getText = (value) => {
      return `<div class='text-center'> <span class='score-value text-white'> ${
         videoRiskScore || videoDetailsData?.risk_score
      } </span>  </div>`
   }

   useEffect(() => {
      const bar = new ProgressBar.SemiCircle('#chart-container1', {
         strokeWidth: 15,
         trailColor: '#FFFFFF4D',
         trailWidth: 15,
         easing: 'easeInOut',
         duration: 1400,
         svgStyle: null,
         text: {
            value: '',
            alignToBottom: false,
            className: 'progressbar__label at-dashboard'
         },
         step: (state, bar) => {
            const value = bar.value()

            // Simulate gradient from #98FF23 (lime green) to #27D089 (teal green)
            const start = { r: 152, g: 255, b: 35 } // #98FF23
            const end = { r: 39, g: 208, b: 137 } // #27D089

            const r = Math.round(start.r + (end.r - start.r) * value)
            const g = Math.round(start.g + (end.g - start.g) * value)
            const b = Math.round(start.b + (end.b - start.b) * value)

            const strokeColor = `rgb(${r}, ${g}, ${b})`

            bar.path.setAttribute('stroke', strokeColor)
            bar.path.setAttribute('fill', 'none')

            const percentValue = Math.round(value * 100)
            if (percentValue === 0) {
               bar.setText('')
            } else {
               bar.setText(getText(percentValue))
            }

            bar.text.style.color = strokeColor
         }
      })
      if (bar) {
         if (videoDetailsData?.risk_score || videoRiskScore) {
            bar.animate((videoRiskScore || videoDetailsData?.risk_score) / 100)
         } else {
            bar.animate(0)
         }
      }

      return () => {
         bar.destroy() // Cleanup on component unmount
      }
   }, [videoDetailsData])

   return (
      <div
         style={{
            backgroundImage: `url(${SentimentBgImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
         }}>
         <div className="card">
            <div className="risk sentiment-score-section">
               <div className="d-flex justify-content-between align-items-center">
                  <h4 className="channel-score-title">Video Risk Score</h4>
               </div>

               <>
                  {videoDetailsData?.risk_score && videoDetailsData?.is_content_summary ? (
                     <div className="progress-bar-section">
                        
                        <div id="chart-container1"></div>
                        <div className="progress-bar-labels">
                           <span className="progress-label start">0</span>
                           <span className="progress-label end">100</span>
                        </div>
                     </div>
                  ) : (
                     <>
                        <div id="chart-container1" style={{ display: 'none' }}></div>
                        <p className="mt-3">Risk analysis is not yet complete.</p>
                     </>
                  )}

                  {videoRiskScore ||
                  (videoDetailsData?.global_risk_score && videoDetailsData?.risk_score) ? (
                     <div className="sentiment-desc">
                        <span className="at-text-light video-sentiment-text">
                           This video has {globalRiskScore} points{' '}
                           {globalRiskScore >= 0 ? 'higher ' : 'lower '}
                           than the channel risk score
                        </span>
                     </div>
                  ) : null}
               </>
            </div>
         </div>
      </div>
   )
}

export default DRiskScore
